import { render, staticRenderFns } from "./salesOrderDetails.vue?vue&type=template&id=e535cd2c&scoped=true"
import script from "./salesOrderDetails.vue?vue&type=script&lang=js"
export * from "./salesOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./salesOrderDetails.vue?vue&type=style&index=0&id=e535cd2c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e535cd2c",
  null
  
)

export default component.exports